<template
  ><v-dialog v-model="value" persistent max-width="50rem">
    <v-card>
      <v-toolbar color="primary darken-1" dark dense>
        {{ this.isEdit ? $t("portfolio.Reflections.edit") : $t("portfolio.Reflections.add") }}
        <v-spacer></v-spacer>

        <v-btn icon dark @click="value = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-form ref="reflectionForm" v-model="formValid">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  rows="5"
                  no-resize
                  :rules="[
                    value => value.length >= 3 || $t('portfolio.Reflections.validation.minLength')
                  ]"
                  v-model="reflection.reflectionText"
                  :label="$t('portfolio.Reflections.reflectionText')"
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <custom-file-uploader
                  v-if="value"
                  ref="uploader"
                  @file-uploaded="onUploaded"
                  locationName="Portfolio"
                ></custom-file-uploader>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" :disabled="!formValid" @click="submitReflection">{{
            $t("save")
          }}</v-btn>
          <v-btn color="red" text @click="value = false">{{ $t("cancel") }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog></template
>

<script>
import DxFileUploader from "devextreme-vue/file-uploader";
import { mapState } from "vuex";
import customFileUploader from "../../custom-file-uploader.vue";

export default {
  name: "ReflectionsDialog",
  components: {
    DxFileUploader,
    customFileUploader
  },
  props: {
    workSampleGuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isEdit: false,
      formValid: false,
      value: false,
      allowedFileExtensions: [
        ".jpg",
        ".jpeg",
        ".gif",
        ".png",
        ".bmp",
        ".mp4",
        ".wmv",
        ".flv",
        ".avi",
        ".webm",
        ".weba",
        ".wav",
        ".mp3",
        ".aac",
        ".pdf",
        ".doc",
        ".docx",
        ".xls",
        ".xlsx",
        ".ppt",
        ".pptx",
        ".txt",
        ".zip",
        ".rar"
      ],
      chunks: [],
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      reflection: {
        workSampleGuid: "",
        reflectionText: "",
        files: []
      }
    };
  },
  computed: {
    ...mapState(["UploaderUrl"])
  },
  methods: {
    submitReflection() {
      this.$refs.reflectionForm.validate();
      if (!this.formValid) {
        return;
      }
      if (this.isEdit) {
        this.axios
          .post("/Reflection/Update", this.reflection)
          .then(() => {
            this.$emit("edit", this.reflection);
          })
          .catch(error => {
            console.error("Error updating reflection:", error);
          });
      } else {
        this.axios
          .post("/Reflection/Create", this.reflection)
          .then(res => {
            this.reflection = res.data.data;

            this.$emit("add", this.reflection);
          })
          .catch(error => {
            console.error("Error adding reflection:", error);
          });
      }
      this.value = false;
    },
    clear() {
      this.reflection = {
        workSampleGuid: "",
        reflectionText: "",
        files: []
      };
    },
    showDialog() {
      this.clear();
      this.reflection.workSampleGuid = this.workSampleGuid;

      this.isEdit = false;
      this.value = true;
      if (this.$refs.uploader) {
        this.$refs.uploader.instance.reset();
      }
    },
    showEditDialog(reflection) {
      this.clear();
      this.isEdit = true;
      this.reflection = reflection;
      this.value = true;
      if (this.$refs.uploader) {
        this.$refs.uploader.instance.reset();
      }
    },
    onUploaded(e) {
      const fileRes = JSON.parse(e.request.responseText).data;
      this.reflection.files.unshift({ fileUrl: fileRes.fileUrl });
    },
    onUploadProgress(e) {
      this.chunks.push({
        segmentSize: e.segmentSize,
        bytesLoaded: e.bytesLoaded,
        bytesTotal: e.bytesTotal
      });
    }
  }
};
</script>
